/**
 * This is a wrapper around the useTranslation hook from react-i18next,
 * that allows us to highlight all the text in translation edit mode.
 */

import React from 'react';
import { useTranslation as useBaseI18nTranslation } from 'react-i18next';
import { useTranslationsEditContextSelector } from './translations-edit-context';
import { TranslationEditModeTextWrapper } from './translation-edit-mode-text-wrapper';

export function useTranslation() {
  const i18nComponents = useBaseI18nTranslation();
  let editMode = false;
  try {
    [editMode] = useTranslationsEditContextSelector(['editMode']);
  } catch (e) {
    /* eslint-disable-next-line no-console */
    console.log('Missing TranslationsEditContextProvider; probably due to being rendered in LIT. Temporarily ignoring editMode.',e);
  }
  if (!editMode) {
    return i18nComponents;
  }

  // if the translated string is used in a context where a string is required, set wrapAsElementNotString=false.
  const t = (key, options = {}, wrapAsElementNotString = true) => {
    const originalTranslation = i18nComponents.t(key, options);
    if (typeof originalTranslation !== 'string') {
      return originalTranslation;
    }
    if (!wrapAsElementNotString) {
      return `${originalTranslation} (${key})`;
    }
    return <TranslationEditModeTextWrapper translationKey={key}>{originalTranslation}</TranslationEditModeTextWrapper>;
  };
  return { ...i18nComponents, t };
}
